(function (restored, undefined) {

    const mapStyle = [{
        'featureType': 'administrative',
        'elementType': 'all',
        'stylers': [
            {'visibility': 'on'},
            {'lightness': 33},
        ],
    },
    {
        'featureType': 'landscape',
        'elementType': 'all',
        'stylers': [
            {'color': '#f2e5d4'}
        ]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
            {'color': '#c5dac6'}
        ]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'labels',
        'stylers': [
            {'visibility': 'on'},
            {'lightness': 20},
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'all',
        'stylers': [
            {'lightness': 20}
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [
            {'color': '#c5c6c6'}
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
            {'color': '#e4d7c6'}
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry',
        'stylers': [
            {'color': '#fbfaf7',}
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [
            {'visibility': 'on'},
            {'color': '#acbcc9'}
        ]
    }];




    function addScript(url, callback) {
        var script = document.createElement('script');
        if (callback) script.onload = callback;
        script.type = 'text/javascript';
        script.src = url;
        document.body.appendChild(script);
    }


    async function calculateDistances(data, origin) {

        const stores = [];
        const destinations = [];

        // Build parallel arrays for the store IDs and destinations
        data.forEach((store) => {
            const storeNum = store.getProperty('storeid');
            const storeLoc = store.getGeometry().get();

            stores.push(storeNum);
            destinations.push(storeLoc);
        });

        // Retrieve the distances of each store from the origin
        // The returned list will be in the same order as the destinations list
        const service = new google.maps.DistanceMatrixService();
        const getDistanceMatrix =
            (service, parameters) => new Promise((resolve, reject) => {
                service.getDistanceMatrix(parameters, (response, status) => {
                    if (status != google.maps.DistanceMatrixStatus.OK) {
                        reject(response);
                    } else {
                        const distances = [];
                        const results = response.rows[0].elements;
                        for (let j = 0; j < results.length; j++) {
                            const element = results[j];
                            const distanceText = element.distance.text;
                            const distanceVal = element.distance.value;
                            const distanceObject = {
                                storeid: stores[j],
                                distanceText: distanceText,
                                distanceVal: distanceVal,
                            };
                            distances.push(distanceObject);
                        }

                        resolve(distances);
                    }
                });
            });


        const distancesList = await getDistanceMatrix(service, {
            origins: [origin],
            destinations: destinations,
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.IMPERIAL,
        });

        distancesList.sort((first, second) => {
            return first.distanceVal - second.distanceVal;
        });

        return distancesList;
    }


    restored.shops_map = function (container) {

        if (!container) return;

        const panel = container.querySelector("div.panel");
        
        const filter_element = container.querySelector(".location-search");
        const filter = container.querySelector("input.search");

        const map_container = container.querySelector(".map");

        const place_template = 'content' in document.createElement("template") ? container.querySelector("template.place-template") : null;
        const info_template = 'content' in document.createElement("template") ? container.querySelector("template.info-template") : null;
        const place_fields = ["name", "address", "address2", "hours", "phone", "town", "postcode"];
        
        const initial_zoom = 7;
        const initial_centre = { lat: 53.80, lng: -1.689423 };

        let map;
        let geocoder;
        let origin_marker;
        let info_window;

        function clear_panel() {
            while (panel.lastChild) panel.removeChild(panel.lastChild);
        }


        function do_search(address) {
            
            address = {
                address: address,
                bounds: map.getBounds()
            };

            geocoder.geocode(address, function(a, d) {
                if (d == google.maps.GeocoderStatus.OK) {
                    google.maps.event.trigger(map_container, "geocode", a[0])
                } else {
                    console.log("Geocoding error: ", d, a);
                }
            })
        }


        function create_store_place_from_template(store, distanceText) {

            const place = place_template.content.cloneNode(true);        
        
            if (!place.children[0]) return place;

            const place_container = place.children[0];
            place_container.dataset.storeid = store.getProperty("storeid");
            place_container.addEventListener('click', store_clicked);

            place_fields.forEach( prop_name => {
                const field = place.querySelector(`.${prop_name}`);
                if (field) field.textContent = store.getProperty(prop_name);
            });
            
            if (distanceText) {
                const field = place.querySelector(".distance-text");
                if (field) field.textContent = distanceText;
            }
            
            return place;
        }

        function create_store_place(store, distanceText) {

            if (place_template) {
                return create_store_place_from_template(store, distanceText);
            }
        
            const place = document.createElement("div")
            place.classList.add("place");
            place.dataset.storeid = store.getProperty("storeid");


            place_fields.forEach( prop_name => {
                const el = document.createElement('div');
                el.classList.add(prop_name);
                el.textContent = store.getProperty(prop_name);
                place.appendChild(el);    
            });
        
            if (distanceText) {
                const text = document.createElement('div');
                text.classList.add('distanceText');
                text.textContent = distanceText;
                place.appendChild(text);    
            }
    
            place.addEventListener('click', store_clicked);
            return place;
    
        }


        function create_store_info_content_from_template(store) {
            
            const info = info_template.content.cloneNode(true);        
        
            if (!info.children[0]) return info;

            const info_container = info.children[0];
            // info_container.dataset.storeid = store.getProperty("storeid");

            place_fields.forEach( prop_name => {
                const field = info.querySelector(`.${prop_name}`);
                if (field) field.textContent = store.getProperty(prop_name);
            });

            const directions = info_container.querySelector("a.get_directions");
            console.log(directions);
            if (directions) {
                const geo = store.getGeometry().get();
                directions.href = `https://www.google.com/maps/dir/?api=1&destination=${geo.lat()},${geo.lng()}`
            }

            return info;
        }


        function create_store_info_content(store) {
            
            if (info_template) return create_store_info_content_from_template(store);

            const info = document.createElement("div")
            info.classList.add("info");
            info.dataset.storeid = store.getProperty("storeid");

            place_fields.forEach( prop_name => {
                const el = document.createElement('div');
                el.classList.add(prop_name);
                el.textContent = store.getProperty(prop_name);
                info.appendChild(el);    
            });
        
    
            info.addEventListener('click', store_clicked);
            return info;            
        }
    

        function showStoresList(stores) {

            if (stores.length == 0) {
                console.log('empty stores');
                return;
            }    
    
            clear_panel();
    
            stores.forEach((store) => {
                // Add store details
                const currentStore = map.data.getFeatureById(store.storeid);
                panel.appendChild(create_store_place(currentStore, store.distanceText));
            });
    
            return;
        }


        function reset_view() {
            map.setCenter(initial_centre);
            map.setZoom(initial_zoom);
            panel.querySelectorAll(".selected").forEach( e => e.classList.remove("selected"));
            origin_marker.setVisible(false);
            filter.value = '';
            clear_panel();
            info_window.close();
            map.data.forEach(store => panel.appendChild(create_store_place(store)));      
        }

        function show_store_info_window(store) {
            info_window.close();
            const position = store.getGeometry().get();
            info_window.setContent(create_store_info_content(store));
            info_window.setPosition(position);
            info_window.setOptions({pixelOffset: new google.maps.Size(0, -30)});
            info_window.open(map);                 
        }

        function store_clicked(event) {
            
            if (!this.dataset.storeid) return;

            if (this.classList.contains("selected")) {
                reset_view();
                return;
            }

            panel.querySelectorAll(".selected").forEach( e => e.classList.remove("selected"));

            this.classList.add("selected")
            var store = map.data.getFeatureById(this.dataset.storeid);
            // var geo = store.getGeometry();
            // map.setCenter(geo.get()), map.setZoom(14);
            // origin_marker.setVisible(false);
            show_store_info_window(store);
        
        }
        
        async function set_origin(location) {

            if (!location) return reset_view();
    
            var origin = location;

            map.setCenter(origin);
            origin_marker.setPosition(origin);
            origin_marker.setVisible(true);

            const rankedStores = await calculateDistances(map.data, origin);
            showStoresList(rankedStores);     
        }

        restored.init_map = function () {

            // Create the map.
            map = new google.maps.Map(map_container, {
                zoom: initial_zoom,
                center: initial_centre,
                styles: mapStyle,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false
            });


            const svg_marker = {
                path: "M213.285,0h-0.608C139.114,0,79.268,59.826,79.268,133.361c0,48.202,21.952,111.817,65.246,189.081,c32.098,57.281,64.646,101.152,64.972,101.588c0.906,1.217,2.334,1.934,3.847,1.934c0.043,0,0.087,0,0.13-0.002,c1.561-0.043,3.002-0.842,3.868-2.143c0.321-0.486,32.637-49.287,64.517-108.976c43.03-80.563,64.848-141.624,64.848-181.482,C346.693,59.825,286.846,0,213.285,0z M274.865,136.62c0,34.124-27.761,61.884-61.885,61.884,c-34.123,0-61.884-27.761-61.884-61.884s27.761-61.884,61.884-61.884C247.104,74.736,274.865,102.497,274.865,136.62z",
                fillColor: "blue",
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 0.1,
                anchor: new google.maps.Point(220, 410),
            };
                    
            origin_marker = new google.maps.Marker({
                map: map,
                icon: svg_marker
            });
            info_window = new google.maps.InfoWindow()

            // Load the stores GeoJSON onto the map, and fill the panel with initial shop data
            map.data.loadGeoJson(" //restoredfurniture.co.uk/cdn/shop/t/24/assets/stores.json?v=157188872695999193311791378264", { idPropertyName: 'storeid' }, features => {
                features.forEach((store) => {
                    panel.appendChild(create_store_place(store));
                });        
            });

            // Search / autocomplete 
            filter.addEventListener('submit', function(event) {
                event.preventDefault();
                // var search_text = filter.querySelector("input").value;
                // do_search(search_text);
                
            });

            const options = {
              componentRestrictions: { country: "uk" },
              fields: ["address_components", "geometry", "icon", "name"],
              strictBounds: false,
              types: ["(regions)"],
            };

            const autocomplete = new google.maps.places.Autocomplete(filter, options);     
            autocomplete.addListener('place_changed', async () => {
                const place = autocomplete.getPlace();

                if (!place.geometry) await set_origin(null);
                else await set_origin(place.geometry.location);
                

               
            });
            

            if (filter_element) {

                const geo_button = filter_element.querySelector("button.geolocate");
                if (geo_button) {
                    if (navigator.geolocation) {
                        geo_button.addEventListener("click", (event) => {
                            event.preventDefault();
                            navigator.geolocation.getCurrentPosition((position) => {
                                const pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude                                    
                                };
                                // console.log("Geolocate: ", pos);
                                set_origin(pos);
                            });
                        })
                    } else {
                        geo_button.classList.add("hidden");
                    }
                }   

                if (filter_element.classList.contains("overlay-control")) {
                    filter_element.parentElement.removeChild(filter_element);
                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(filter_element);
                }
            }
            // geocoder = new google.maps.Geocoder;
            // google.maps.event.addListener(map_container, "geocode", async function(event) {
            //     if (event.geometry) {

            //         event.geometry.viewport ? map.fitBounds(event.geometry.viewport) : (map.setCenter(event.geometry.location),
            //         map.setZoom(11));

            //         origin_marker.setVisible(false);
            //         let origin = map.getCenter();
    
            //         origin_marker.setPosition(origin);
            //         origin_marker.setVisible(true);

            //         const rankedStores = await calculateDistances(map.data, origin);
            //         showStoresList(rankedStores);

            //     } else
            //         do_search(event.name)
            // });


            // Handle clicks on shop markers
            map.data.addListener('click', (event) => {
                show_store_info_window(event.feature);            
            });

            // Add reset button
            // const reset = document.createElement("div");
            // reset.classList.add("reset-button");
            // const b =document.createElement("button");
            // b.innerText = "Reset";
            // b.addEventListener('click', reset_view);
            // reset.appendChild(b);
            
            // map.controls[google.maps.ControlPosition.TOP_LEFT].push(reset);


        }

        if (window.google) {
            restored.init_map();
        } else {
            addScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyC54iHIEJXX_iTHaSMWJrbUPLCw8qPYbvs&libraries=places&callback=restored.init_map");
        }
        

    }

}(window.restored = window.restored || {}));
